import { useQuery } from '@tanstack/react-query';

// API endpoint for taskbloom-nest Supabase Edge Function
// Edge Function uses service role key to bypass RLS policies
const SUPABASE_URL = import.meta.env.VITE_TASKBLOOM_SUPABASE_URL || 'https://mxtkabejdsoqkgtqjaaw.supabase.co';
const FUNCTION_NAME = 'mechanical-dashboard';

interface Equipment {
  id: string;
  code: string;
  name: string;
  location: string;
  latest_report_status: 'passed' | 'warning' | 'failed' | null;
  latest_report_id: string | null;
  last_report_date: string | null;
  last_status: string | null;
}

interface WorkUnitDashboardData {
  id: string;
  unit_name: string;
  name: string;
  description: string | null;
  total_equipment: number;
  passed_count: number;
  warning_count: number;
  failed_count: number;
  normal_equipment: number;
  warning_equipment: number;
  failed_equipment: number;
  equipment: Equipment[];
}

export const useMechanicalDashboardData = () => {
  return useQuery<WorkUnitDashboardData[], Error>({
    queryKey: ['mechanicalDashboard'],
    queryFn: async () => {
      try {
        const url = `${SUPABASE_URL}/functions/v1/${FUNCTION_NAME}`;
        console.log('Fetching mechanical dashboard from Edge Function:', url);
        
        // Get anon key for taskbloom Supabase
        const anonKey = import.meta.env.VITE_TASKBLOOM_SUPABASE_ANON_KEY || 
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im14dGthYmVqZHNvcWtndHFqYWF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQwNTU4MjUsImV4cCI6MjAzOTYzMTgyNX0.QNLi5ZxZ8bNEe0gV6rGx3Nb99jkPR38ePdNI7y8dItA';
        
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${anonKey}`,
            'apikey': anonKey,
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Error response:', errorText);
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }

        const data = await response.json();
        console.log('Fetched dashboard data from Edge Function:', data);
        
        // Data is already in the correct format from Edge Function
        return data;
      } catch (error) {
        console.error('Error fetching mechanical dashboard data:', error);
        throw error;
      }
    },
    staleTime: 0, // No cache - always fetch fresh data
    refetchOnWindowFocus: true, // Auto-refetch when user returns to tab
    retry: 2,
  });
};
